module.exports = __webpack_public_path__ + "img/2-1.11ae9be8.png";